import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "../../../../components";
import { MonitorFaturamentoService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";
import MonitorFatCard from "./monitor-fat-card.view";

const monitorFaturamentoService = new MonitorFaturamentoService();
const LIMIT = 8;

function MonitorFatItensSemGiro({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [quantidade, setQuantidade] = useState(0);
  const [itens, setItens] = useState([]);
  const [limite, setLimite] = useState(LIMIT);

  useEffect(() => {
    buscarItensSemGiro();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscarItensSemGiro() {
    setLoading(true);
    const result = await monitorFaturamentoService.itensSemGiro(filtrosBody);
    if (!result.isAxiosError) {
      setQuantidade(result.data?.quantidade || 0);
      setItens(result.data?.itens || []);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const listaExibida = itens.slice(0, limite);
  const restante = quantidade - listaExibida.length;

  return (
    <MonitorFatCard
      titulo={`Itens sem Giro (${quantidade})`}
      icone="ph-warning-circle"
      loading={loading}
    >
      <Table size="small">
        <TableHead sx={{ backgroundColor: "#f8fafc" }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, width: 44 }} align="center">
              #
            </TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Produto</TableCell>
            <TableCell align="center" sx={{ fontWeight: 700 }}>
              Estoque
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 700 }}>
              Valor
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listaExibida.map((row, i) => (
            <TableRow
              key={row.codigo || i}
              sx={{ "&:hover": { backgroundColor: "#f8fafc" } }}
            >
              <TableCell align="center">
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    mx: "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 12,
                    fontWeight: 700,
                    color: i < 3 ? "#fff" : "#475569",
                    backgroundColor:
                      i < 3 ? ["#FFD700", "#C0C0C0", "#CD7F32"][i] : "#e2e8f0",
                  }}
                >
                  {i + 1}
                </Box>
              </TableCell>
              <TableCell
                sx={{
                  maxWidth: 220,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={row.produto}
              >
                {row.produto}
              </TableCell>
              <TableCell
                align="center"
                sx={{ fontWeight: 700, color: "#1e293b" }}
              >
                {row.estoque}
              </TableCell>
              <TableCell align="right">{formatPrice(row.valor)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        {restante > 0 && (
          <Typography
            variant="caption"
            onClick={() => setLimite(limite + LIMIT)}
            color="text.disabled"
            sx={{
              display: "block",
              mt: 1,
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            + {restante} outros itens sem giro
          </Typography>
        )}
        {listaExibida.length > LIMIT && (
          <Typography
            variant="caption"
            onClick={() => setLimite(LIMIT)}
            color="text.disabled"
            sx={{
              display: "block",
              mt: 1,
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            - esconder
          </Typography>
        )}
      </Box>
    </MonitorFatCard>
  );
}

export default MonitorFatItensSemGiro;
